const media = {
    path: null,
    absolutePath: null,
    path_images: [],
    type: null,
    preview: null,
    id: null
}

export default {media}
